module.exports = __webpack_public_path__ + "img/asian-special-2.70ec2e05.jpg";